
const maxNegativePTO = -3;

export const checkAnnualPTOAmountLimit = (balances, nextYearBalances, type) => {
  if (balances[type]) {
    const annuallyUsedPTO = balances[type].annuallyUsed;
    const maxYearlyPTOAmount = balances[type].expectedAnnualValue;
    if (annuallyUsedPTO + maxNegativePTO > maxYearlyPTOAmount) return true;
  }

  if (nextYearBalances[type]) {
    const annuallyUsedPTO = nextYearBalances[type].annuallyUsed;
    const maxYearlyPTOAmount = nextYearBalances[type].expectedAnnualValue;
    if (annuallyUsedPTO + maxNegativePTO > maxYearlyPTOAmount) return true;
  }

  return false;
}

export const checkCurrentPTOAmountLimit = (balances, nextYearBalances, type) => {
  if (balances[type]) {
    if (balances[type].balance < maxNegativePTO) return true;
  }

  if (nextYearBalances[type]) {
    if (nextYearBalances[type].balance < maxNegativePTO) return true;
  }

  return false;
}

export const checkNegativePTOAccruable = (balances, type) => {
  if (balances[type]) {
    if (balances[type].balance < 0 && balances[type].balance >= maxNegativePTO) return true;
  }

  return false;
}

export const checkBalanceLegitimate = (balances, nextYearBalances, type) => {
  if (balances[type]) {
    if (balances[type].balance < 0) return true;
  }

  if (nextYearBalances[type]) {
    if (nextYearBalances[type].balance < 0) return true;
  }

  return false;
}




// WEBPACK FOOTER //
// ./src/helpers/timeoffRuleChecker.js